import competitionFilters from './competitions'
import numberFilters from './numbers'
import rankingFilters from './rankings'
import sessionFilters from './sessions'
import stringFilters from './strings'
import timestampFilters from './timestamps'

export default Object.assign(
  {},
  competitionFilters,
  numberFilters,
  rankingFilters,
  sessionFilters,
  stringFilters,
  timestampFilters,
)



// WEBPACK FOOTER //
// ./src/app/filters/index.js